import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Alert,
  Container,
  Label,
  FormGroup,
} from "reactstrap";
import { connect } from "react-redux";
import logo from "../assets/images/logo-main.png";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link, useHistory, withRouter } from "react-router-dom";
import { checkLogin, apiError } from "../store/actions";

import spinner from "../assets/images/loadingGif.gif";

const Login = (props) => {
  const history = useHistory(); // Create a history object from useHistory()
  const [username, setUsername] = useState(""); // Use state to store username
  const [password, setPassword] = useState("");

  const handleSubmit = (event, values) => {
    props.checkLogin(values, props.history);
  };

  return (
    <React.Fragment>
      <Container fluid className="p-0">
        <Row className="no-gutters">
          <Col lg={5}>
            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div className="w-100">
                <Row className="justify-content-center">
                  <Col lg={9}>
                    <div>
                      <div className="text-center">
                        <div>
                          <Link to="/" className="logo">
                            <img src={logo} height="60" alt="logo" />
                          </Link>
                        </div>
                        <p className="text-muted">
                          Sign in to continue to CloudNova.
                        </p>
                      </div>

                      {props.loginError && (
                        <Alert className="mt-3 mb-0" color="danger">
                          Unable to login to Demo Register Application
                        </Alert>
                      )}

                      <div className="p-2 mt-5">
                        <AvForm
                          className="form-horizontal"
                          onValidSubmit={handleSubmit}
                        >
                          <FormGroup>
                            <AvField
                              name="userName"
                              value={username}
                              type="text"
                              className="form-control"
                              id="username"
                              placeholder="Enter username"
                              onChange={(e) => setUsername(e.target.value)}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Please enter username",
                                },
                              }}
                            />
                          </FormGroup>

                          <FormGroup>
                            <AvField
                              name="password"
                              value={password}
                              type="password"
                              className="form-control"
                              id="userpassword"
                              placeholder="Enter password"
                              onChange={(e) => setPassword(e.target.value)}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Please enter a password",
                                },
                              }}
                            />
                          </FormGroup>

                          <div className="mt-4 text-center">
                            <Button
                              color="primary"
                              className="w-md waves-effect waves-light"
                              type="submit"
                              disabled={props.loading}
                            >
                              Log In
                            </Button>
                          </div>
                          {props.loading && (
                            <div
                              style={{
                                margin: "20px",
                                display: "flex",
                                direction: "row",
                                alignContent: "center",
                                alignItems: "center",
                                justifyContent: "center",
                                justifyItems: "center",
                              }}
                            >
                              <img src={spinner} width="80px" alt="Spinner" />
                            </div>
                          )}

                          <div className="mt-4 text-center">
                            <Link to="/forgot-password" className="text-muted">
                              <i className="mdi mdi-lock mr-1"></i> Forgot your
                              password?
                            </Link>
                          </div>
                        </AvForm>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col lg={7}>
            <div className="authentication-bg">
              {/* bg-overlay */}
              <div className=""></div>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { loginError, loading } = state.login;
  //const { loginError } = "login";
  return { loginError, loading };
};

export default withRouter(
  connect(mapStatetoProps, { checkLogin, apiError })(Login)
);
